import { render, staticRenderFns } from "./GetnetPedidoParciais.vue?vue&type=template&id=b1513976&scoped=true"
import script from "./GetnetPedidoParciais.vue?vue&type=script&lang=js"
export * from "./GetnetPedidoParciais.vue?vue&type=script&lang=js"
import style0 from "./GetnetPedidoParciais.vue?vue&type=style&index=0&id=b1513976&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1513976",
  null
  
)

export default component.exports